import BaseApiService from './BaseApiService';

class DrugBrandApiService extends BaseApiService {
    constructor() {
        super('brands');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.brands ? response.brands : [];
    }

    async update({id, limited_loe_month, limited_loe_year, full_loe_month, full_loe_year}) {
        const data = {
            limited_loe_month, limited_loe_year, full_loe_month, full_loe_year
        };
        try {
            const response = await this.request({ method: 'PUT', url: '/' + id, data });
            return response && response.updatedLoeEvents ? response.updatedLoeEvents : null;

        } catch (error) {
            throw error;
        }
    }
}

export default new DrugBrandApiService();
